/**
 * Erweitert Knockout um eine Convenience-Funktion, um die Async-Extension zu nutzen
 */
export default function applyCustomization() {
    ko.asyncComputed = <T>(readFunc: () => T, initialValue?: T, suppressInitialExecution?: boolean): KnockoutAsyncComputed<T> => {

        let isInitial = true;
        let trigger = ko.observable().extend({ notify: 'always' });
        let target = ko.computed(() => {
            trigger();
            if (!suppressInitialExecution) {
                return readFunc();
            }
            else {
                if (isInitial) {
                    isInitial = false;
                    return initialValue;
                }
                else {
                    return readFunc();
                }
            }
        }).extend({ async: initialValue, notify: 'always' });

        target.evaluate = () => {
            const def = $.Deferred();

            target.subscribeOnce((value) => {
                def.resolve(value);
            });

            trigger.valueHasMutated();

            return def;
        };

        return target;
    };
}